// libs
import React, { memo, useEffect } from 'react';
import { styled } from '@nykaa/ui-components';

// constants
import { TEXT } from './constants';

// analytics
import { onPageLoad } from './analytics';

// icon
import ImageBase from 'components/ImageV2';

// styles
const Container = styled.div`
  text-align: center;
  color: #000;
  padding: ${({ theme }) =>
    `0 ${theme.spacing.spacing200} ${theme.spacing.spacing80} ${theme.spacing.spacing100} `};
  width: 100%;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const Image = styled(ImageBase)`
  background: transparent;
  width: 132px;
  height: 132px;
`;

const Info = styled.p`
  ${({ theme }) => theme.typography.titleMedium};
  margin: ${({ theme }) => theme.spacing.spacing40} 0;
  color: ${({ theme }) => theme.colors.textPrimary};
`;

const Description = styled.div`
  ${({ theme }) => theme.typography.bodyMedium};
  margin-bottom: ${({ theme }) => theme.spacing.spacing80};
  color: ${({ theme }) => theme.colors.textPrimary};
`;

const Button = styled.button`
  width: 100%;
  ${({ theme }) => `
    border-radius: ${theme.borders.mwebButtonBorderRadius};
    padding: ${theme.spacing.spacing40} ${theme.spacing.spacing60};
    border: 1px solid ${theme.colors.textOutline};
    color: ${theme.colors.surface};
    background: ${theme.colors.primary};
  `};
  ${({ theme }) => theme.typography.buttonMedium};
`;

interface ISomethingWentWrongProps {
  onBack?: VoidFunction;
  className?: string;
  label?: string;
}

export const INFO_CLASSNAME = 'info';

function SomethingWentWrong({
  onBack,
  className = '',
  label = TEXT.BACK_LINK_LABEL,
}: ISomethingWentWrongProps) {
  const clickHandler = () => {
    if (onBack) {
      onBack();
    } else {
      window.location.href = '/';
    }
  };

  useEffect(() => {
    onPageLoad();
  }, []);

  return (
    <Container data-test={'something-went-wrong'} className={className}>
      <Image
        width={80}
        height={80}
        src="https://images-static.nykaa.com/nykdesignstudio-images/pub/media/something_went_wrong.svg"
      />
      <Info className={INFO_CLASSNAME}>{TEXT.INFO}</Info>
      <Description>{TEXT.DESCRIPTION}</Description>
      <Button kind="primary" size="large" shape="default" fullWidth onClick={clickHandler}>
        {label}
      </Button>
    </Container>
  );
}

export default memo(SomethingWentWrong);
